module.exports = {"aspectRatio":2.888888888888889}